import './PageBalance.css';


function PageBalance() {
    return (
        <h1>PageBalance</h1>
    );
}

export default PageBalance

